import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import api from "./api";
import Login from "./components/Login";
import Register from "./components/Register";
import ChatApp from "./components/ChatApp";

function AppRoutes() {
  const { theme, isDark } = useTheme();
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setCurrentUser(res.data))
      .catch(() => setCurrentUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
          background: theme.bg,
          color: theme.text,
          fontSize: 14,
          fontFamily: "'Inter',sans-serif",
        }}
      >
        Yükleniyor...
      </div>
    );

  return (
    <div
      style={{
        height: "100vh",
        background: theme.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: currentUser ? "16px" : "0",
        transition: "background 0.3s",
      }}
    >
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: isDark ? "#242018" : "#e6e0d4",
            color: isDark ? "#c8c3bc" : "#2a2420",
            border: isDark
              ? "1px solid rgba(255,255,255,0.08)"
              : "1px solid rgba(0,0,0,0.08)",
            fontSize: "12px",
            fontFamily: "'Inter',sans-serif",
            borderRadius: "10px",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              currentUser ? (
                <Navigate to="/chat" replace />
              ) : (
                <Login setCurrentUser={setCurrentUser} />
              )
            }
          />
          <Route
            path="/register"
            element={
              currentUser ? <Navigate to="/chat" replace /> : <Register />
            }
          />
          <Route
            path="/chat/*"
            element={
              currentUser ? (
                <ChatApp
                  currentUser={currentUser}
                  setCurrentUser={setCurrentUser}
                />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="*"
            element={<Navigate to={currentUser ? "/chat" : "/login"} replace />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppRoutes />
    </ThemeProvider>
  );
}
